const clearSpaces = (value: string, isNumber?: boolean) => {
	if (!value) {
		return '';
	}
	if (!isNumber) {
		return value;
	}

	return value.replace(/\s/g, '');
};

const getFormatterNumber = (value: string, isNumber?: boolean): string => {
	if (!value) {
		return '';
	}

	if (isStringANumber(value)) {
		return value;
	}

	if (!isNumber) {
		return value;
	}

	return new Intl.NumberFormat('ru-RU', {
		maximumFractionDigits: 2,
	}).format(+clearSpaces(value, isNumber)).replace(",", ".").trim();
}

const isStringANumber = (value: string): boolean => {
	const trimmedValue = value.replace(/\s/g, '')
	return isNaN(Number(trimmedValue))
}

export {
	clearSpaces,
	getFormatterNumber,
	isStringANumber
}



// WEBPACK FOOTER //
// ./src/helpers/getFormatterNumber.ts